import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba09fa44&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=ba09fa44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba09fa44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba09fa44')) {
      api.createRecord('ba09fa44', component.options)
    } else {
      api.reload('ba09fa44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba09fa44&scoped=true&", function () {
      api.rerender('ba09fa44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/legal-case-page/index.vue"
export default component.exports